import azAZ from 'antd/locale/az_AZ';
import deDE from 'antd/locale/de_DE';
import enUS from 'antd/locale/en_US';
import esES from 'antd/locale/es_ES';
import frFR from 'antd/locale/fr_FR';
import hiIN from 'antd/locale/hi_IN';
import ptBR from 'antd/locale/pt_BR';
import ptPT from 'antd/locale/pt_PT';
import roRO from 'antd/locale/ro_RO';
import ruRU from 'antd/locale/ru_RU';
import trTR from 'antd/locale/tr_TR';
import ukUA from 'antd/locale/uk_UA';

import LOCALES from 'constants/locales';

export const getAntdLocale = (lang: string) => {
  switch (lang) {
    case LOCALES.SPANISH_ES:
    case LOCALES.SPANISH_LATAM:
      return esES;
    case LOCALES.PORTUGUESE_BR:
      return ptBR;
    case LOCALES.PORTUGUESE_PT:
      return ptPT;
    case LOCALES.FRENCH_FR:
      return frFR;
    case LOCALES.RUSSIAN_RU:
      return ruRU;
    case LOCALES.GERMAN_DE:
      return deDE;
    case LOCALES.HINDI_IN:
      return hiIN;
    case LOCALES.TURKISH_TR:
      return trTR;
    case LOCALES.AZERBAIJANI_AZ:
      return azAZ;
    case LOCALES.ROMANIAN_RO:
      return roRO;
    case LOCALES.UKRAINIAN:
      return ukUA;
    case LOCALES.ENGLISH_US:
    default:
      return enUS;
  }
};
